export enum RightDrawerTabs {
  Results = "results",
  HandHistory = "hand-history",
  Chat = "chat",
}